<template>
  <div class="input-wrap u-mt0 u-pt0">
    <label v-if="label !== 'none'" for=""
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
      <span v-if="isTap" class="taps">※２回押すと解除できます</span>
    </label>
    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <div class="input-group" v-for="(option, index) in options" :key="index">
      <input
        type="radio"
        :name="setKey"
        :id="`${setKey}_${index}`"
        :value="option.value"
        @change="updateValue"
        :checked="value.includes(option.value)"
        :disabled="disabled || option.disabled"
      />
      <label class="block" :for="`${setKey}_${index}`">{{ option.text }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    label: { type: String, required: true },
    value: { type: String, required: true, default: null },
    setKey: { type: String, required: true },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    isTap: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
  },
  methods: {
    updateValue(e) {
      this.$emit('input-emit', this.setKey, e.target.value)
    },
  },
}
</script>
<style lang="scss" scoped>
input[type='radio']:disabled + label {
  opacity: 50%;
}
</style>
